import tinycolor2 from 'tinycolor2';
import { styled } from '@classify/react-core-components/styles';
import { Paper } from '@mui/material';
import ListAlt from '@mui/icons-material/ListAlt';
import { translate } from '@openclassrooms/translations';

const WhiteBackground = styled('div')(({ theme: { palette, breakpoints, zIndex } }) => ({
  background: palette.background.primary,
  borderRadius: '32px 0px 0px 32px',
  zIndex: zIndex.fab,

  [breakpoints.up('sm')]: {
    borderRadius: '0px 32px 32px 0px',
  },
}));

const Wrapper = styled(Paper, { shouldForwardProp: (prop) => prop !== 'backgroundColor' })<{
  backgroundColor: string;
}>(({ theme: { spacing, palette, breakpoints }, backgroundColor }) => ({
  backgroundColor,
  padding: 'initial',
  border: 'initial',
  borderRadius: '32px 0 0 32px',
  boxShadow: 'none',

  '& > div': {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(1.5, 2),
    cursor: 'pointer',
    borderRadius: '32px 0 0 32px',
  },

  [breakpoints.up('sm')]: {
    borderRadius: '0 32px 32px 0',
    borderLeft: `1px solid ${palette.layout.line.divider}`,

    '& > div': {
      borderRadius: '0 32px 32px 0',
    },
  },
}));

export interface TocTogglerButtonProps {
  categoryColor: string;
  onClick: () => void;
}

const TocTogglerButton = ({ onClick, categoryColor }: TocTogglerButtonProps) => {
  const lighterCategoryColor = tinycolor2(categoryColor).setAlpha(0.08).toString();

  return (
    <WhiteBackground>
      <Wrapper
        backgroundColor={lighterCategoryColor}
        color={categoryColor}
        aria-label={translate('video_conferencing.chat.title.label')}
        component="button"
        tabIndex="0"
        onClick={onClick}
      >
        <div tabIndex="-1">
          <ListAlt sx={{ color: categoryColor || 'brand.primary' }} />
        </div>
      </Wrapper>
    </WhiteBackground>
  );
};

export default TocTogglerButton;
